import Rellax from 'rellax';

const parallaxCircles = new Rellax('.js-parallax-circle');